<template>
  <g>
    <!-- class visible let you see elements on hover -->
    <!-- This are the lines (only visible on hover) -->
    <line
      v-for="(datum, index) in d"
      :class="['y-tooltip-line', { 'line-visible': scatterIndex === index }]"
      :key="'line-y-' + index"
      :x1="p.scaleX(datum[c.xAxis])"
      :x2="p.scaleX(datum[c.xAxis])"
      :y2="p.scaleY(datum[serie.key])"
      :y1="p.scaleY(p.minY)"
      @mouseenter="changeOver(index, p.scaleR(datum.size))"
      @mouseout="changeOver(null, null)"
      stroke="var(--primary-yellow)"
    ></line>
    <line
      v-for="(datum, index) in d"
      :class="['x-tooltip-line', { 'line-visible': scatterIndex === index }]"
      :key="'line-x-' + index"
      :x1="c.yAxisWidth + c.yAxisTranslate.x"
      :x2="p.scaleX(datum[c.xAxis])"
      :y2="p.scaleY(datum[serie.key])"
      :y1="p.scaleY(datum[serie.key])"
      @mouseenter="changeOver(index, p.scaleR(datum.size))"
      @mouseout="changeOver(null, null)"
      stroke="var(--primary-yellow)"
    ></line>
    <!-- This are the text after the lines (only on hover)-->
    <rect
      v-for="(datum, index) in d"
      :key="'api-rect-x' + index"
      :x="p.scaleX(datum[c.xAxis])"
      :y="p.scaleY(p.minY) + 5"
      :transform="'translate(-17,0)'"
      :width="computedWidth(datum.sulphur)"
      :class="['api-rect', { visible: scatterIndex === index }]"
    ></rect>
    <rect
      v-for="(datum, index) in d"
      :key="'api-rect-y' + index"
      :x="c.yAxisWidth + c.yAxisTranslate.x"
      :y="p.scaleY(datum[serie.key]) + 5"
      :transform="'translate(-20,-18)'"
      :width="computedWidth(datum.api)"
      :class="['api-rect', { visible: scatterIndex === index }]"
    ></rect>
    <text
      v-for="(datum, index) in d"
      :key="'api-' + index"
      :class="['number-tooltip', { visible: scatterIndex === index }]"
      :x="c.yAxisWidth + c.yAxisTranslate.x - 14"
      :y="p.scaleY(datum[serie.key]) + 5"
      fill="var(--primary-yellow)"
      >{{ datum.api }}</text
    >
    <text
      v-for="(datum, index) in d"
      :key="'sulphur-' + index"
      :class="['number-tooltip', { visible: scatterIndex === index }]"
      :x="p.scaleX(datum[c.xAxis]) - 10"
      :y="p.scaleY(p.minY) + 23"
      fill="var(--primary-yellow)"
      >{{ datum.sulphur }}</text
    >
    <!-- This is the tooltip made of: rect, text -->
    <rect
      v-for="(datum, index) in d"
      :class="['tooltip', { visible: scatterIndex === index }]"
      :key="'tooltip-' + index"
      :x="
        +p.scaleX(datum[c.xAxis]) < 900
          ? p.scaleX(datum[c.xAxis])
          : p.scaleX(datum[c.xAxis]) -
            (p.scaleR(datum.size) * 2 + 40) -
            computedWidth(datum.label)
      "
      :y="p.scaleY(datum[serie.key])"
      :width="computedWidth(datum.label) + 'px'"
      :transform="`translate(${p.scaleR(datum.size) + 10}, -11)`"
    >
    </rect>
    <text
      v-for="(datum, index) in d"
      :key="'label-' + index"
      :x="
        +p.scaleX(datum[c.xAxis]) < 900
          ? p.scaleX(datum[c.xAxis])
          : p.scaleX(datum[c.xAxis]) -
            p.scaleR(datum.size) * 2 -
            (computedWidth(datum.label) + 5)
      "
      :y="p.scaleY(datum[serie.key])"
      :class="['label-tooltip', { visible: scatterIndex === index }]"
      :transform="`translate(${p.scaleR(datum.size) + 20}, 4)`"
      fill="#fff"
      >{{ datum.label }}</text
    >
  </g>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import wrap from "@/charts/mixins/wrap.js";

export default {
  name: "TooltipScatterPlot",
  props: ["p", "c", "d", "serie"],
  mixins: [wrap],
  methods: {
    computedWidth(label) {
      const labelWidth = this.measureText(label.toString(), 16);
      return labelWidth;
    },

    changeOver(index, height) {
      this.setScatterIndex(index);
      this.heightTooltip = height;
    },
    ...mapActions({
      setScatterIndex: "ui/setScatterIndex",
    }),
  },
  computed: {
    ...mapGetters({ scatterIndex: "ui/scatterIndex" }),
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  width: toRem(193);
  height: toRem(22);
  fill: var(--source-color-dark);
  transition: all 0.3s ease;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
}

.y-tooltip-line {
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
}
.x-tooltip-line {
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
}

.api-rect {
  height: toRem(27);
  transition: all 0.3s ease;
  opacity: 0;
  fill: var(--source-color-dark);
  visibility: hidden;
}

.y-tooltip-line {
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
}
.x-tooltip-line {
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
}

.number-tooltip {
  @include number-S;
  opacity: 0;
  visibility: hidden;
}

.label-tooltip {
  @include dida-S;
  opacity: 0;
  visibility: hidden;
}

.visible {
  opacity: 1;
  visibility: visible;
}

.line-visible {
  opacity: 0.5;
  visibility: visible;
}
</style>
